import { render, staticRenderFns } from "./MedicalEducationReportData.vue?vue&type=template&id=46877b4c"
import script from "./MedicalEducationReportData.vue?vue&type=script&lang=js"
export * from "./MedicalEducationReportData.vue?vue&type=script&lang=js"
import style0 from "./MedicalEducationReportData.vue?vue&type=style&index=0&id=46877b4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports